import ShowVM from './show-vm';

export default {
  init () {
    const $node = $('#program_container')[0];
    const programData = JSON.parse($('#program_json').val());

    Kadenze.WebApp.fbEventTrack('ViewContent', {
      content_category: 'program',
      content_type: 'product',
      content_ids: [programData.id],
      content_name: programData.title
    });

    ga('send', { hitType: 'event', eventCategory: 'program',
      eventAction: 'ViewContent', eventLabel: programData.title
    });

    ko.applyBindings(new ShowVM(programData), $node);

    // bind enroll modal events
    $('#js-course-enroll-modal--authenticate').on('shown.bs.modal', () => {
      setTimeout(() => {
        $('#js-course-enroll-modal--authenticate').find('input.form-control')[0].focus();
      }, 10);
      //
      // setTimeout solves race condition with overarching modal focus event
      // that sets focus to the first button in the modal
      //
    });

    $('#js-course-enroll-modal--fields').on('shown.bs.modal', () => {
      setTimeout(() => {
        $('#js-course-enroll-modal--fields').find('input.form-control')[0].focus();
      }, 10);
      //
      // setTimeout solves race condition with overarching modal focus event
      // that sets focus to the first button in the modal
      //
    });
  }
};
